import React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
import Segments from './segments/Segments';
import ResetPassword from './layout/ResetPassword';
import AddCluster from './clusters/addcluster';
import DetailCluster from './clusters/detailcluster';
import EditCluster from './clusters/editcluster';
import Clusters from './clusters';
import TypographyPage from './typography/Typography';
import ForceUser from './layout/forceUserDialog';
import MyCalendar from "./calendar";

export default [
    <Route exact path="/configuration" render={() => <Configuration />} />,
    <Route exact path="/segments" render={() => <Segments />} />,
    <Route exact path="/resetpassword/:token" component={ResetPassword} noLayout />,
    <Route exact path="/addcluster" component={AddCluster} render={() => <Clusters />} />,
    <Route exact path="/showcluster" component={DetailCluster} render={() => <Clusters />} />,
    <Route exact path="/editcluster" component={EditCluster} render={() => <Clusters />} />,
    <Route exact path="/typography" component={TypographyPage} />,
    <Route exact path="/forceuser" component={ForceUser} noLayout />,
    <Route exact path="/calendar" component={MyCalendar} />
];
